module.exports = __webpack_public_path__ + "bg_main.jpg?d67ec50324ac817b063893599db946ab";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_main.jpg
// module id = 18
// module chunks = 0